/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDealerDetailsHeader_user$ref = any;
export type PdpSharedDealerDetailsHeader_user = {
    readonly canShowSellerName: boolean | null;
    readonly " $refType": PdpSharedDealerDetailsHeader_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsHeader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canShowSellerName",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '166cbc5213651741bece2eda9e089072';
export default node;
